<template>
  <h1 class="sub-title">Target Players Filters</h1>
  <ResponsiveTable class="fields-container">
    <!-- Organizations -->
    <Cell class="flex" :width="`${labelCellWidth}`">
      <LabelCustomized label="Organizations" required />
    </Cell>
    <Cell class="flex items-center" :width="`${fieldCellWidth}`">
      <ItemsField
        v-model="filters.organizations"
        @click-empty="handleClickFieldEmtyArea(organizationsDialogRef)"
      >
        <template #default="{ addItems }">
          <SelectFromListerDialog
            ref="organizationsDialogRef"
            btn-title="Add Organization Filters"
            dialog-title="Select Organization(s) to Add"
            selected-items-link-base="/organizations/edit"
            dataTestId="live-stream-add-org-filters"
            @add="addItems($event)"
            :ItemsLister="OrganizationsLister"
          />
        </template>
      </ItemsField>
    </Cell>

    <!-- Locations -->
    <Cell class="flex" :width="`${labelCellWidth}`">
      <LabelCustomized label="Locations" />
    </Cell>
    <Cell class="flex items-center" :width="`${fieldCellWidth}`">
      <ItemsField
        v-model="filters.locations"
        @click-empty="handleClickFieldEmtyArea(locationsDialogRef)"
      >
        <template #default="{ addItems }">
          <SelectFromListerDialog
            ref="locationsDialogRef"
            btn-title="Add Location Filters"
            dialog-title="Select Locations(s) to Add"
            selected-items-link-base="/locations/edit"
            dataTestId="live-stream-add-location-filters"
            add-button-test-id="live-stream-location-filter-add"
            @add="addItems($event)"
            :ItemsLister="LocationsLister"
          />
        </template>
      </ItemsField>
    </Cell>

    <!-- Orientations -->
    <Cell class="flex" :width="`${labelCellWidth}`">
      <LabelCustomized label="Orientations" />
    </Cell>
    <Cell class="flex items-center" :width="`${fieldCellWidth}`">
      <ItemsField
        v-model="filters.orientations"
        @click-empty="handleClickFieldEmtyArea(orientationsDialogRef)"
      >
        <template #default="{ addItem }">
          <SelectOrientationDialog
            ref="orientationsDialogRef"
            @select="addItem($event)"
            btn-title="Add Orientation Filter"
            dialog-title="Select Orientation to Add"
          />
        </template>
      </ItemsField>
    </Cell>

    <!-- Player Tags -->
    <Cell class="flex" :width="`${labelCellWidth}`">
      <LabelCustomized label="Player Tags" />
    </Cell>
    <Cell class="flex items-center" :width="`${fieldCellWidth}`">
      <ItemsField
        v-model="filters.playerTags"
        @click-empty="handleClickFieldEmtyArea(playersTagsDialogRef)"
      >
        <template #default="{ addItem }">
          <SelectPlayersTagDialog
            ref="playersTagsDialogRef"
            @select="addItem($event)"
            btn-title="Add Player Tag Filter"
            dialog-title="Select Player Tag to Add"
          />
          <!-- <SelectFromListerDialog btn-title="Add Player Tag Filter" @add="addItems($event)" /> -->
        </template>
      </ItemsField>
    </Cell>
    <Cell>
      <MatchingPlayers v-bind="{filters}" />
    </Cell>
  </ResponsiveTable>
</template>

<script setup lang="ts">
import { ResponsiveTable } from '@/components/ResponsiveTable';
import Cell from '@/components/ResponsiveTable/Cell.vue';
import LabelCustomized from '@/components/form-fields/LabelCustomized/LabelCustomized.vue';
import ItemsField from '@/components/form-fields/ItemsField/ItemsField.vue';
import SelectFromListerDialog from '@/components/Dialog/SelectFromListerDialog/SelectFromListerDialog.vue';
import OrganizationsLister from '@/views/SettingsViews/OrganizationsListView/OrganizationsLister/OrganizationsLister.vue';
import LocationsLister from '../../SettingsViews/LocationsListView/LocationsLister/LocationsLister.vue';
import SelectOrientationDialog from '@/components/Dialog/SelectOrientationDialog/SelectOrientationDialog.vue';
import SelectPlayersTagDialog from "@/components/Dialog/SelectPlayersTagDialog/SelectPlayersTagDialog.vue";
import MatchingPlayers from './MatchingPlayers/MatchingPlayers.vue';
import { ref, watch } from 'vue';
const props = defineProps(['modelValue']);
const emit = defineEmits(['update:modelValue']);
const filters = ref(props.modelValue);
watch([filters], () => {
  emit('update:modelValue', filters);
});

const organizationsDialogRef = ref();
const locationsDialogRef = ref();
const orientationsDialogRef = ref();
const playersTagsDialogRef = ref();

function handleClickFieldEmtyArea(dialogRefValue: any) {
  dialogRefValue.open();
}

const labelCellWidth = "8rem";
const fieldCellWidth = "20rem";
const tableWidth = "30rem";
</script>


<style lang="scss" scoped>
.fields-container {
  margin-top: 1rem;
  margin-bottom: 0;
  max-width: v-bind(tableWidth);
}
.sub-title {
  font-size: 1.5em;
  font-weight: bold;

  @include theme-old {
    color: #252949;
  }

  @include theme-new {
    color: #252949;
  }

  letter-spacing: 2px;
}
</style>